interface StreamHandlerOptions {
  url: string;
  method?: string;
  headers: Record<string, string>;
  body: Record<string, unknown>;
  signal?: AbortSignal;
  onUpdate?: (text: string) => Promise<void>;
  errorPrefix: string;
  parseContent: (data: unknown) => string;
}

export async function handleStreamResponse(options: StreamHandlerOptions): Promise<string> {
  try {
    const requestOptions = {
      method: options.method || 'POST',
      headers: options.headers,
      body: JSON.stringify(options.body),
      signal: options.signal
    };

    const response = await fetch(options.url, requestOptions);

    if (!response.ok) {
      const errorData = await response.text().catch(() => "");
      throw new Error(`${options.errorPrefix} (${response.status}): ${errorData || response.statusText}`);
    }

    if (!response.body) {
      throw new Error("响应没有body");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let fullText = '';

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      // 处理数据块
      const chunk = decoder.decode(value);
      const lines = chunk.split('\n').filter(line => line.trim() !== '');

      for (const line of lines) {
        if (line.includes('[DONE]')) continue;

        try {
          // 提取JSON数据
          let jsonData: unknown;
          if (line.startsWith('data: ')) {
            jsonData = JSON.parse(line.substring(6));
          } else {
            jsonData = JSON.parse(line);
          }

          // 使用自定义解析器提取内容
          const content = options.parseContent(jsonData);
          if (content) {
            fullText += content;
            if (options.onUpdate) {
              await options.onUpdate(content);
            }
          }
        } catch (e) {
          console.error('解析流式响应出错:', e);
        }
      }
    }

    return fullText;
  } catch (error) {
    console.error(`流式处理${options.errorPrefix}出错:`, error);
    throw error;
  }
} 